document.addEventListener("DOMContentLoaded", function () {
    // Inicializar WaveSurfer para el audio principal
    const wavesurfer = WaveSurfer.create({
        container: "#waveform",
        waveColor: "WHITE",
        progressColor: "#880000",
        cursorColor: "transparent",
        barWidth: 2,
        responsive: true,
        height: 80,
        backend: 'MediaElement',
        preload: 'auto'
    });

    // Cargar el archivo principal
    wavesurfer.load("https://cdn.shopify.com/s/files/1/0914/1387/2946/files/maashup_fuego_05598110-31c7-4381-85a2-95a61ac9f7bc.mp3?v=1748891153");

    // Botón de Play/Pause para el audio principal
    const playPauseBtn = document.getElementById("playPauseBtn");
    playPauseBtn.addEventListener("click", () => {
        if (wavesurfer.isPlaying()) {
            wavesurfer.pause();
            playPauseBtn.textContent = "▶";
        } else {
            wavesurfer.play();
            playPauseBtn.textContent = "⏸";
        }
    });

    // Lista de todas las muestras de audio
    const samples = [
        { id: "waveform1", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Lilith_-_130_BPM_G_Min.wav?v=1747351139" }, { id: "waveform2", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Asmodeus_-_144_BPM_D_Min.wav?v=1747351139" },
        { id: "waveform3", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_ACCENT_Tabernacle_-_174_BPM_D_Min.wav?v=1747351163" }, { id: "waveform4", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_808_Crushing_C.wav?v=1747351359" },
        { id: "waveform5", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_BASS_Deceit_C.wav?v=1747351583" }, { id: "waveform6", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_BASS_Unholy_C.wav?v=1747351583" },
        { id: "waveform7", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_DONK_Curse_C.wav?v=1747351693" }, { id: "waveform8", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_REESE_Inverted_Cross_C.wav?v=1747351704" },
        { id: "waveform9", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_808_MIDI_Fear_-_184_BPM_F_Min.wav?v=1747351884" }, { id: "waveform10", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_808_MIDI_La_H_-_146_BPM_A_Min.wav?v=1747351884" },
        { id: "waveform11", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Hihat_MIDI_Slow_-_120_BPM.wav?v=1747351884" }, { id: "waveform12", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Hihat_MIDI_Broly_-_133_BPM.wav?v=1747351884" },
        { id: "waveform13", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Drum_Loop_1_-_164_BPM_D_Min.wav?v=1747351520" }, { id: "waveform14", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Drum_Loop_5_-_165_BPM_E_Min.wav?v=1747351519" },
        { id: "waveform15", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Drum_Loop_8_-_153_BPM_E_Min.wav?v=1747351519" }, { id: "waveform16", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Drum_Loop_14_-_135_BPM_D_Min.wav?v=1747351533" },
        { id: "waveform17", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/DEMON_MODE_flp_1.mp3?v=1747353379" }, { id: "waveform18", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/DETROIT_DEMON.mp3?v=1747353538" },
        { id: "waveform19", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/EPIC_DEMON_flp.mp3?v=1747353366" }, { id: "waveform20", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/EPIC_DEMON_MODE_flp_4.wav?v=1747353386" },
        { id: "waveform21", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/DRILL_SECCION.mp3?v=1747352275" }, { id: "waveform22", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/BEAT_ELADIO_CURSO_TRAP.mp3?v=1747352383" }
    ];

    let wavesurfers = {};

    // 🔄 Inicializar las muestras en lotes
    let currentIndex = 0;
    const batchSize = 4; // Puedes ajustar si quieres 6, 8, etc.
    const loadDelay = 300; // Milisegundos entre cada lote

    function loadNextBatch() {
        const batch = samples.slice(currentIndex, currentIndex + batchSize);
        batch.forEach(sample => {
            wavesurfers[sample.id] = WaveSurfer.create({
                container: `#${sample.id}`,
                waveColor: "white",
                progressColor: "#880000",
                cursorColor: "transparent",
                barWidth: 2,
                responsive: true,
                height: 40,
                backend: 'MediaElement',
                preload: 'auto'
            });

            wavesurfers[sample.id].load(sample.file);
        });

        currentIndex += batchSize;

        if (currentIndex < samples.length) {
            setTimeout(loadNextBatch, loadDelay);
        }
    }

    loadNextBatch(); // Iniciar carga por lotes

    // Botones de reproducción para cada muestra de audio
    document.querySelectorAll(".play-btn").forEach(btn => {
        btn.addEventListener("click", function () {
            const waveformId = this.nextElementSibling.id;
            if (wavesurfers[waveformId].isPlaying()) {
                wavesurfers[waveformId].pause();
                this.textContent = "▶";
            } else {
                // Pausar todas las demás muestras antes de reproducir una nueva
                Object.keys(wavesurfers).forEach(id => wavesurfers[id].pause());
                document.querySelectorAll(".play-btn").forEach(b => (b.textContent = "▶"));

                wavesurfers[waveformId].play();
                this.textContent = "⏸";
            }
        });
    });

    // Función para preguntas frecuentes (FAQ)
    document.querySelectorAll(".faq-question").forEach(btn => {
        btn.addEventListener("click", function () {
            const answer = this.nextElementSibling;
            const toggleSign = this.querySelector(".faq-toggle");

            if (answer.style.maxHeight) {
                answer.style.maxHeight = null;
                answer.style.opacity = "0";
                toggleSign.textContent = "+";
            } else {
                document.querySelectorAll(".faq-answer").forEach(ans => {
                    ans.style.maxHeight = null;
                    ans.style.opacity = "0";
                });
                document.querySelectorAll(".faq-toggle").forEach(sign => (sign.textContent = "+"));

                answer.style.maxHeight = answer.scrollHeight + "px";
                answer.style.opacity = "1";
                toggleSign.textContent = "-";
            }
        });
    });
});
